var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prefix"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4999 4.5C18.8363 3.83805 17.9372 3.46631 16.9999 3.46631C16.0626 3.46631 15.1635 3.83805 14.4999 4.5L14.2099 4.79L19.2099 9.79L19.4999 9.5C20.1618 8.83638 20.5336 7.93732 20.5336 7C20.5336 6.06268 20.1618 5.16362 19.4999 4.5ZM5.5499 13.5C5.19016 13.8617 4.92859 14.3091 4.7899 14.8L3.7899 18.45C3.72963 18.6998 3.73453 18.9608 3.80413 19.2082C3.87373 19.4555 4.0057 19.6808 4.18739 19.8625C4.36907 20.0442 4.59438 20.1762 4.84172 20.2458C5.08905 20.3154 5.35012 20.3203 5.5999 20.26L9.2499 19.21C9.7408 19.0713 10.1882 18.8097 10.5499 18.45L17.7899 11.21L12.7899 6.21L5.5499 13.5Z",
    fill: "black",
    fillOpacity: 0.65
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditPen);
export default __webpack_public_path__ + "static/media/ic-edit-pen.899453a1c52aed22597435c431f807cc.svg";
export { ForwardRef as ReactComponent };